<template>
  <div>
    <canvas class="canvas" ref="canvasRef"></canvas>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return { RT: 0, CH: 0 };
      }
    }
  },
  data() {
    return {
      canvas: null
    };
  },
  methods: {
    init() {
      this.canvas = this.$refs.canvasRef;
      if (!this.canvas) return;
      let ctx = this.canvas.getContext("2d");
      this.canvas.width = this.canvas.clientWidth * window.devicePixelRatio;
      this.canvas.height = this.canvas.clientHeight * window.devicePixelRatio;
      // 缩放绘图上下文
      ctx.scale(1, 1);

      let canvasWidth = this.canvas.width;
      let canvasHeight = this.canvas.height;
      let fontColor = "#1a7ad3";
      ctx.imageSmoothingEnabled = false;
      ctx.lineWidth = 1;
      const img = new Image();
      img.src = require("../../../../assets/icon/classroomObservation/rt-ch_echarts.png");
      img.onload = () => {
        ctx.drawImage(img, 25, 25, 250, 250);
        ctx.beginPath();
        ctx.arc((250*parseFloat(this.data.RT))+25,(250-(250*parseFloat(this.data.CH))+25), 4, 0, 2 * Math.PI);
        ctx.fill();
        ctx.stroke();
      };

      ctx.fillStyle = "black";
      ctx.font = `20px serif`;
      ctx.fillText("1", 10, 40);
      ctx.fillText("Ch", 0, 150);
      ctx.fillText("0", 10, 290);
      ctx.fillText("Rt", 140, 295);
      ctx.fillText("1", 280, 275);

      ctx.fillStyle = fontColor;
      ctx.font = "italic bold 24px Arial";
      ctx.fillText(`RT=${this.data.RT}    CH=${this.data.CH}`, 40, 330);
    },
    drawRoundedRect(ctx, x, y, width, height, radius) {
      // 限制 radius 的最大值，防止它超过矩形的宽度或高度的一半
      const actualRadius = Math.min(radius, width / 2, height / 2);

      ctx.beginPath();
      ctx.moveTo(x + actualRadius, y); // 起点，矩形顶部的左侧

      // 右上角的弧线
      ctx.arcTo(x + width, y, x + width, y + height, actualRadius);

      // 右下角的弧线
      ctx.arcTo(x + width, y + height, x, y + height, actualRadius);

      // 左下角的弧线
      ctx.arcTo(x, y + height, x, y, actualRadius);

      // 左上角的弧线
      ctx.arcTo(x, y, x + width, y, actualRadius);

      ctx.closePath();
      ctx.fill(); // 填充颜色
    }
  },
  mounted() {
    this.init();
    window.addEventListener("resize", () => {
      if (!this.$refs.canvasRef) return;
      this.init();
    });
  }
};
</script>

<style scoped>
.canvas {
  width: 300px;
  height: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/classroomObservation/components/echartsRTCH.vue